import { takeLatest } from 'redux-saga/effects';
import { all, put } from 'redux-saga/effects';
import { call } from 'redux-saga/effects';
import { apiCall } from './../app/config';
import { AxiosResponse } from "axios";
import { dirfActions } from './reducer';


function* requestDirfWorker() {
  try {
    const res: AxiosResponse = yield call(apiCall, {
      url: '/portalrh/dirf',
      method: 'get'
    })
    console.log('documentos retornados', res.data)

    yield put(dirfActions.requestDirfSuccess(res.data))
  } catch (error: any) {
    console.log('error',error)
    yield put(dirfActions.requestDirfError(
      error?.response?.data?.message ? error.response?.data?.message : JSON.stringify(error)
    ))
  }
}

export function* dirfSaga() {
  yield all([
    takeLatest("dirf/requestDirf", requestDirfWorker)
  ])
}